<template>
	<div class="audio-button-box" :class="className">
		<button type="default" class="audio-button" :class="{'on': audioPlay, 'off': !audioPlay}" @click="toggleAudio"></button>
	</div>
</template>

<script>
	export default {
		props: {
			className: {
				type: String,
				default: ''
			},
		},
		computed: {
			audioPlay() {
				return this.$store.state.audioPlay;
			}
		},
		methods: {
			toggleAudio() {
				if(this.audioPlay) {
					this.$store.state.audioPlay = false;
					this.$bus.emit('stopReportAudio');
				}else {
					this.$store.state.audioPlay = true;
					this.$bus.emit('playReportAudio');
				}
			}
		}
	}
</script>

<style>
</style>
